import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'

export const withInteractiveStore = (WrappedComponent) => {
  const Template = ({ runInitFunction, forwardedRef, ...props }) => {

    const interactive = useSelector(state => state.interactive);
    const assets = useSelector(state => state.assets);

    useEffect(() => {
      if (runInitFunction) {
        runInitFunction();
      }
    }, [interactive, runInitFunction])
    
    return <WrappedComponent interactive={interactive} assets={assets} {...props} forwardedRef={forwardedRef}/>
  }

  return React.forwardRef((props, ref) => {
    return <Template {...props} forwardedRef={ref} />;
  });
  
}